module.exports = __webpack_public_path__ + "img/Clear-24px.55a9de28.svg";